import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cluePush } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import BatchUserList from '../BatchUserList/index.vue'
import { shareInfo } from '@dc-platform/dc-interaction'
import { bool } from 'vue-types'

const __default__ = { name: 'LaunchButton' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  // 这个属性用来控制该组件是带边框的button或者链接形式文字
  isLink: {
    type: bool,
    default: false
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const props = __props
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
// 选择负责人后保存他的区域，便于手动修改区域后，和该负责人区域不一样的话就清空负责人
const principalRegion = ref<string>()
const form = ref<any>({})
const emit = __emit
const loginUser = shareInfo.getUserInfo() || {}
const acceptClueSystem = computed(() => {
  if (props.appId === 'cos_fbu') {
    return [
      {
        value: 'cos_fbu',
        label: '谷仓'
      },
      {
        value: 'cos_ofbu',
        label: '谷仓海外'
      }
    ]
  }
  return [
    {
      value: 'cos_lbu',
      label: '云途'
    }
  ]
})
const regionChange = (region: any) => {
  if (props.appId === 'cos_fbu' && region && region.custom && region.custom !== principalRegion.value) {
    form.value.follower = undefined
  }
}
const targetChange = (target: any) => {
  if (props.appId === 'cos_fbu' && target) {
    form.value.subdomain = target
  }
}
const principalChange = (user: any) => {
  if (props.appId === 'cos_fbu' && user) {
    principalRegion.value = user.deptId
    form.value.customerRegion = user.deptId
  }
}
// 保存人员信息到本地
const savePeopleMessage = () => {
  const { conductor, follower, customerRegion } = form.value
  let init = {}
  if (!loginUser.work_code) {
    return
  }
  const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
  if (leadManagePeople) {
    init = JSON.parse(leadManagePeople)
  }
  if (!init[loginUser.work_code]) {
    init[loginUser.work_code] = {}
  }
  init[loginUser.work_code][props.appId] = {
    conductor,
    follower,
    customerRegion
  }
  localStorage.setItem('dc-cos-lbu-leadManage', JSON.stringify(init))
}

// 获取上次选择人员
const initPeopleMessage = async () => {
  try {
    const init = {
      cos_lbu: {
        conductor: 'zt20309' // 李科燕
      },
      cos_fbu: {
        conductor: 'zt18054' // 覃恒梅
      }
    }
    const firstClue = props.data[0] as ClueManage
    const expectPushInfo = firstClue.expectPushInfo
    if (expectPushInfo && expectPushInfo.length) {
      // 其实只有一条
      expectPushInfo.forEach((e: any, i: number) => {
        form.value = {
          ...form.value,
          receiver: e.acceptor ? e.acceptor : props.appId,
          subdomain: e.acceptor ? e.acceptor : props.appId,
          conductor: firstClue.createBy,
          conductorName: firstClue.createByName,
          customerRegion: e.region,
          follower: e.follower,
          followerName: e.followerName
        }
      })
    } else {
      let initPeople = init[props.appId]
      const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
      if (leadManagePeople) {
        const leadManagePeopleObj = JSON.parse(leadManagePeople)
        const userConductor = leadManagePeopleObj[loginUser.work_code]
        if (userConductor && userConductor[props.appId]) {
          initPeople = userConductor[props.appId]
        }
      }
      // 设置初始值
      if (initPeople.conductor && initPeople.conductor) {
        form.value = {
          ...form.value,
          conductor: initPeople.conductor
        }
      }
      if (initPeople.follower) {
        form.value = {
          ...form.value,
          follower: initPeople.follower
        }
      }
      if (initPeople.customerRegion) {
        form.value = {
          ...form.value,
          customerRegion: initPeople.customerRegion
        }
      }
    }
  } catch (error) {
    console.log('getData error: ', error)
  }
}

const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 谷仓市场线索投放不过滤线索类型
  if (props.appId !== 'cos_fbu') {
    const errorData = props.data.find((item) => item.clueType !== 2)
    if (errorData) {
      DcMessage.error('请选择有效线索进行投放！')
      return
    }
  }
  visible.value = true
  form.value = {
    receiver: props.appId,
    subdomain: props.appId,
    clueIdList: props.data.map((item) => item.clueId)
  }
  initPeopleMessage()
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    savePeopleMessage()
    cluePush(form.value)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('投放处理中，结果稍后通过飞书消息提醒')
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      onClick: showModal,
      type: __props.isLink?'link':'ghost'
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["type"]),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      title: "投放",
      class: "cluePush",
      width: "670px",
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: form.value,
              ref_key: "formRef",
              ref: formRef,
              class: "launchTable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "clueIdList",
                  label: "客户名称",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: form.value.clueIdList,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.clueIdList) = $event)),
                      mode: "multiple",
                      disabled: true,
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.clueId,
                            value: item.clueId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.customerName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "receiver",
                  label: "投放到",
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: form.value.receiver,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.receiver) = $event)),
                      placeholder: "请选择",
                      options: acceptClueSystem.value,
                      onChange: targetChange
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                (form.value.receiver !== 'cos_lbu')
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      name: "customerRegion",
                      label: "客户区域",
                      rules: [{ required: true, message: '请选择' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          appId: "cos_fbu",
                          deptInfoId: "815717",
                          value: form.value.customerRegion,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerRegion) = $event)),
                          placeholder: "请选择客户区域",
                          onChange: regionChange
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, {
                  name: "conductor",
                  rules: {
            required: true,
            message: '请选择'
          },
                  label: "对接人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(BatchUserList, {
                      value: form.value.conductor,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.conductor) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "follower",
                  label: "客户负责人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(BatchUserList, {
                      value: form.value.follower,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.follower) = $event)),
                      onChange: principalChange
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}
}

})